export default {
    companies: [],
    locations: [],
    filter: {
        company: {
            id: null,
            nombre: null,
        },
        location_id: null,
        page: 1,
        perPage: 10,
        sortBy: "id",
        sort: "DESC",
        search: "",
        prod_attachment_id: null,
    },
    reportTypes: { data: [], total: 0 },
    levelsOfRisks: { data: [], total: 0 },
    correctiveActions: { data: [], total: 0 },
    sectionActive: "report-types",
    activeModalForm : false,
    reports : [],
    reportTypesActives : [],
    levelsOfRisksActives : [],
    correctiveActionsActives : [],
    responsibles : [],
    levelsOfRisksActivesLess : [],
    payloadCorrectAct : {
        report_id: null,
        company_id: null,
        responsible_id: null,
        corrective_action_id: null,
        description: '',
        is_completed: null,
        completion_date: '',
        level_risks_initial: null,
        level_risks_current: null,
        page: 1,
        per_page: 10
    },
    correctiveActionsList: []
};
